import React from 'react'
import Help from 'components/Help'

const HelpPage = () => {
  return <Help />
}

export default HelpPage
